import { render, staticRenderFns } from "./build.vue?vue&type=template&id=fd88776a&scoped=true&"
import script from "./build.vue?vue&type=script&lang=js&"
export * from "./build.vue?vue&type=script&lang=js&"
import style0 from "./build.vue?vue&type=style&index=0&id=fd88776a&scoped=true&lang=css&"
import style1 from "./build.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd88776a",
  null
  
)

export default component.exports